import { Navigate, useParams } from "react-router-dom";
import { useGetPortalMyBidsQuery } from "../../../autogen/bff-api";
import { urls } from "../../../urls";
import { usePortalEventUrls } from "../../../common/sourcing-events/portal/usePortalEventUrls";
import { v1BidLinkToCurrent } from "./v1BidLinkToCurrent";

export const LegacyBidLinkRedirect = () => {
  const { bidId } = useParams<{ bidId: string }>();
  const portalUrls = usePortalEventUrls();
  const myBids = useGetPortalMyBidsQuery({});

  if (myBids.isError) return <Navigate to={urls.app.supplier.bids} replace />;
  if (!myBids.data) return null;

  const bid = myBids.data.bids.find((candidate) => candidate.bidId === bidId);
  return <Navigate to={bid ? v1BidLinkToCurrent(portalUrls, bid) : urls.app.supplier.bids} replace />;
};
